const developemnt = {
  apiEndpoints: {
    protocol: "https://",
    server: "",
  },
  profileBook: "someLink"
};
let basicEndpoint = developemnt
export default basicEndpoint